import React, { memo } from 'react';
import { useTheme } from 'emotion-theming';
export var Arrow = /*#__PURE__*/memo(function (_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100%' : _ref$height,
      color = _ref.color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'white' : _ref$variant,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var fillColor = color || colors[variant];
  return /*#__PURE__*/React.createElement("svg", {
    height: height,
    width: width,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34.2 43.2",
    style: {
      enableBackground: 'new 0 0 34.2 43.2'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: fillColor,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: "2,25.5 17.1,40.4 32.2,25.5"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: fillColor,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: "17.1",
    y1: "38.5",
    x2: "17.1",
    y2: "2"
  })));
});